const About = () => {
  return (
    <section
      id="about"
      className="bg-sabriLight text-sabriGray py-16 sm:py-20 px-4 sm:px-6"
    >
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-3xl sm:text-4xl font-title font-bold mb-5 sm:mb-6 text-sabriBlue">
          About Me
        </h2>

        <p className="text-base sm:text-lg leading-relaxed text-gray-700 mb-5 sm:mb-6">
          Hi, I’m <strong>Sabri Abounozha</strong>, an Oregon State University
          computer science graduate, developer, and content creator based in{" "}
          <strong>Salem, Oregon, United States</strong>. I earned my Bachelor of
          Science in Computer Science in June 2026, graduating Summa Cum Laude
          with a 3.86 GPA and an academic focus in human-computer interaction.
        </p>

        <p className="text-base sm:text-lg leading-relaxed text-gray-700 mb-5 sm:mb-6">
          I’ve worked on projects like <strong>Tasktix</strong>, my completed
          Oregon State senior capstone team project, where I contributed a
          responsive homepage, reusable FeatureBlock UI, light/dark themed
          visuals, auth-aware navigation, and frontend test coverage. I’ve also
          built <strong>Corvallis City</strong>, a Kotlin app that showcases
          local recommendations.
        </p>

        <p className="text-base sm:text-lg leading-relaxed text-gray-700 mb-5 sm:mb-6">
          I currently work full-time at <strong>GT Independence</strong> as a
          Processing Specialist, supporting packet requests, missing information
          updates, and outbound follow-up calls.
        </p>

        <p className="text-base sm:text-lg leading-relaxed text-gray-700">
          Outside of work and coding, I’m a content creator on YouTube and Instagram,
          where I share stories about technology, personal growth, and modern
          life. My goal is to bridge the gap between art and technology, creating
          experiences that inspire and connect people around the world.
        </p>
      </div>
    </section>
  );
};

export default About;
